import React from "react";
import { FormControl, ControlLabel, Alert } from "react-bootstrap";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import TCDurationForm from "./payrolladmin-tc-duration/tc-duration-form.jsx";
import moment from "moment";
import immutable from "immutable";
import TCButtonPanel from "./shared/tc-button-panel.jsx";
import { browserHistory } from "react-router";

export default class PayrollAdminTCDuration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            peopleId: null,
            assignId: null,
            offSysId: null,
            timecardId: null,
            weekEnding: null,
            hideButtonPanel: true,
            buttons: "",
            allowEdit: true,
            errors: [],
            warning: "",
            requireNotes: false
        };
        this.role = context.getRouteParam(this, "role");
        this.statusCode = null;

        this.onLoadTimecardCompleted = this.onLoadTimecardCompleted.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onVerify = this.onVerify.bind(this);
        this.onRecallApproved = this.onRecallApproved.bind(this);
    }


    componentDidMount() {
    }

    onSubmit() {
        context.message({
            show: true,
            type: "loading",
            message: "Preparing to submit timecard..."
        });

        const self = this;
        const timecardId = this.state.timecardId;
        let vm = this.state;
        let newNotes = this.refs.durationForm.refs.tcSummary.getNotes().trim();
        ajax.api()
            .put(`add-notes/${timecardId}`, { role: self.role, notes: newNotes })
            .then(function (res) {
                ajax.api()
                    .get(`prepare-timecard-submission/${timecardId}`)
                    .then(function (res) {
                        const redirectFunc = function () {
                            context.message({
                                show: true,
                                message: "Preparing to submit timecard...",
                                type: "loading"
                            });

                            const submitToken = res.data.token
                            browserHistory.push(context.routeUrl(`${self.role}/tc-submit/${submitToken.timecardId}/${escape(submitToken.token)}`));
                            context.message({ show: false });
                        };

                        if (res.data.warningMessages && res.data.warningMessages.length > 0) {
                            let liKey = 1;
                            context.message({
                                show: true,
                                type: 'warning',
                                message: <div>
                                    <ul>
                                        {res.data.warningMessages.map(w => <li key={liKey++}>{w}</li>)}
                                    </ul>
                                    <p>
                                        Are you sure to submit this timecard?
                                    </p>
                                </div>,
                                buttons: "yes,no"
                            }, function (button, s) {
                                if (button == "yes") {
                                    redirectFunc();
                                } else {
                                    context.message({ show: false });
                                }
                            });
                        } else if (res.data.errorMessages && res.data.errorMessages.length > 0) {
                            self.handleErrors(res.data.errorMessages, function () {
                                context.message({ show: false });
                            });
                        } else {
                            redirectFunc();
                        }
                    })
                    .catch(function (err) {
                        let errors = [];
                        let data = err.response.data;
                        if (data.exceptionMessage.length > 1 || data.message.length > 1) {
                            errors.push(data.exceptionMessage || data.message);
                        } else {
                            for (let k in data.data) {
                                errors.push(data.data[k]);
                            }
                        }

                        self.handleErrors(errors, function () {
                            context.message({ show: false });
                        });
                    });
            })
            .catch(function (err) {
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: <div>Error when attempting to add notes.<br />{msg}</div>,
                    buttons: "close"
                });
            });
    }

    onRecallApproved() {
        let self = this;
        let newNotes = this.refs.durationForm.refs.tcSummary.getNotes().trim();
        const timecardId = this.state.timecardId;

        if (newNotes == null || newNotes.length < 1) {
            context.message({
                show: true,
                type: "error",
                message: <div>Notes is required</div>,
                buttons: "ok"
            });
            return false;
        }

        context.message({
            show: true,
            type: "info",
            message: "Are you sure you want to recall this timecard?",
            buttons: "yes,no"
        }, function (button, s) {
            // s is timecardId, timecardId is set as the 3rd parameter of context.message
            if (button === "yes") {
                ajax.api()
                    .put("recall-approved-timecard", { timecardId: timecardId, notes: newNotes })
                    .then(function (res) {
                        self.refs.durationForm.loadTimecard(timecardId);
                    })
                    .catch(function (err) {
                        const data = err.response.data;
                        const msg = data.exceptionMessage || data.message;
                        context.message({
                            show: true,
                            type: "error",
                            message: <div>Error while recalling timecard.<br />{msg}</div>,
                            buttons: "ok"
                        });
                    });
            }
        }, timecardId);
    }

    onVerify() {
        context.message({
            show: true,
            type: "loading",
            message: "Preparing for Verification. Please wait...",
        });

        let self = this;

        const timecardId = this.state.timecardId;
        let newNotes = this.refs.durationForm.refs.tcSummary.getNotes().trim();
        let submitted = this.statusCode == "saved" ? 0 : 1;

        ajax.api()
            .post("payroll-admin/prepare-timecard-verification", {
                timecards: [timecardId],
                submitted: submitted
            })
            .then(res => {
                const data = res.data[0];

                if (data.errorMessages.length > 0) {
                    self.handleErrors(data.errorMessages);
                    setTimeout(() => context.message({ show: false }), 1);
                } else {
                    const redirect = () => {
                        browserHistory.push(context.routeUrl(`${self.role}/tc-approval/${submitted}`));
                    };
                    if (data.warningMessages.length > 0) {
                        let liKey = 0;
                        context.message({
                            show: true,
                            type: 'warning',
                            message: <div>
                                <ul>
                                    {data.warningMessages.map(w => <li key={liKey++}>{w}</li>)}
                                </ul>
                                <p>
                                    Are you sure to verify this timecard?
                                </p>
                            </div>,
                            buttons: "yes,no"
                        }, function (button, s) {
                            if (button == "yes") {
                                context.message({
                                    show: true,
                                    type: "loading",
                                    message: "Processing. Please wait...",
                                });
                                setTimeout(redirect, 1);
                            } else {
                                context.message({ show: false });
                            }
                        });
                    } else redirect();

                }
            })
            .catch(err => {
                const error = err.response.data.exceptionMessage || err.response.data.message;
                self.handleErrors(error);
                setTimeout(() => context.message({ show: false }), 1);
            });
    }

    onLoadTimecardCompleted(tc, errors) {
        const clone = immutable.fromJS(this.state).toJS();
        const buttonConfig = this.prepareButtonPanel(tc);
        clone.timecardId = tc.timecardId;
        clone.offSysId = tc.offsysid;
        clone.assignId = tc.placementId;
        clone.peopleId = tc.peopleId;
        clone.weekEnding = moment(tc.weekEnding).format("MM-DD-YYYY");
        clone.hideButtonPanel = buttonConfig.hideButtonPanel;
        clone.requireNotes = buttonConfig.requireNotes;
        clone.buttons = buttonConfig.buttons;
        clone.errors = (errors == null) ? [] : errors;

        this.statusCode = tc.statusCode.toLowerCase();

        /// knguyen : 12/6/2017 - Enable edit for payroll-admin
        // clone.allowEdit = (this.statusCode === "saved" || this.statusCode === "submitted");              
        clone.warning = "";
        if (tc && tc.statusCode.toLowerCase() !== "saved" && tc.statusCode.toLowerCase() !== "submitted") {
            clone.warning = `Timecard for the weekend ${moment(tc.weekEnding).format("MM/DD/YYYY")} has been ${tc.statusCode.toLowerCase()} already!`;
        }
        clone.allowEdit = true;

        this.setState(clone);
    }

    prepareButtonPanel(tc) {
        const result = {
            hideButtonPanel: true,
            buttons: "",
            requireNotes: false
        };
        if (tc) {
            const statusCode = tc.statusCode.toLowerCase();
            if (statusCode === "saved") {
                result.hideButtonPanel = false;
                result.buttons = "submit,verify";
                result.requireNotes = false;
            } else if (statusCode === "submitted") {
                result.hideButtonPanel = false;
                result.buttons = "verify";
                result.requireNotes = false;
            } else if (statusCode === "approved") {
                result.hideButtonPanel = false;
                result.buttons = "recall-approved";
                result.requireNotes = true;
            }
        }

        return result;
    }

    handleErrors(errors, callback) {
        const clone = immutable.fromJS(this.state).toJS();
        if (typeof (errors) == "string") clone.errors = [errors];
        else clone.errors = errors;
        this.setState(clone, function () {
            window.scrollTo(0, 0);
            if (callback) callback();
        });
    }

    render() {
        const tcWeekEnding = moment(this.state.weekEnding).endOf("week");
        const curWeekEnding = moment().endOf("week");

        let hideGrid = tcWeekEnding.isAfter(curWeekEnding);

        let alert = "";
        let warning = null;

        if (this.state.warning != null && this.state.warning.trim().length != 0) {
            warning = <Alert bsStyle="warning">{this.state.warning}</Alert>;
        }

        if (this.state.errors.length > 0) {
            alert = <Alert bsStyle="danger"><ul>
                {
                    this.state.errors.map(err => <li key={err}>{err}</li>)
                }
            </ul></Alert>;
        }

        return (
            <div className="ap-form-container">
                <div className="container ap-top-margined">
                    <div className="row">
                        <div className="col-md-12 text-center ap-h1">
                            Time Sheet
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4 text-center">
                            <ControlLabel>This timecard is for the week-ending : {this.state.weekEnding}</ControlLabel>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {warning}
                            {alert}
                        </div>
                    </div>
                </div>
                <TCDurationForm timecardId={this.props.params.timecardId} weekEnding={this.state.weekEnding}
                    peopleId={this.state.peopleId} assignId={this.state.assignId} offSysId={this.state.offSysId}
                    allowEdit={this.state.allowEdit}
                    hideGrid={hideGrid}
                    ref="durationForm"
                    onLoadTimecardCompleted={this.onLoadTimecardCompleted}
                    role={this.role}
                    requireNotes={this.state.requireNotes} />
                <TCButtonPanel buttons={this.state.buttons}
                    hidden={this.state.hideButtonPanel}
                    onSubmit={this.onSubmit}
                    onVerify={this.onVerify}
                    onRecallApproved={this.onRecallApproved} />
            </div>
        );
    }
}
